import { createBrowserRouter } from "react-router-dom";
import Login from "./Login";
import { RouterProvider } from "react-router-dom";
import Dashboard from "./NewSurvey/Dashboard";
import PropertyViewDetails from "./PropertyViewDetails";
import SignIn from "./Signin";
import NotFound from "./NotFound";
import HtmlQrCodeScannerComponent from "../components/common/Html5QrcodeScannerComponent";
import BookingForm from "./BookingForm/BookingForm";
import LeadDashboard from "./LeadDashboard";
import Policy from "./common/Policy";
import ValidateClient from "./common/validateclient";
import  Acknowledge from "./acknowledge";
import AuthenticatedLayout from "./AuthenticatedLayout";


const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/client",
      element: <Login />,
    },
       {
      path: "/client/:clientName/acknowledge",
      element: <Acknowledge />,
    },
    {
      path: "/PrivacyPolicy",
      element: <Policy  />,
    },
    {
      path: "/client/:clientName",
      element:<ValidateClient>
          <Login />
        </ValidateClient>,
    },
    {
      element: <AuthenticatedLayout />,
      children: [
        {
          path: "/client/:clientName/booking",
          element: <ValidateClient><BookingForm /></ValidateClient>,
        },
      ]
    },
    {
      path: "/signin",
      element: <SignIn />,
    },
    {
      path: "/new-survey",
      element: <Dashboard />,
    },
    {
      path: "/scanDoor",
      element: <HtmlQrCodeScannerComponent />,
    },
    {
      path: "/Dashboard",
      element: <PropertyViewDetails />,
    },

    {
      path: "/leadDashboard",
      element: <LeadDashboard />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return (
    <div>
      <RouterProvider router={appRouter} />
    </div>
  );
};
export default Body;
